export default "__VITE_ASSET__DHQ09$aU__"